namespace GeniuzPOS.Purchase {
    export interface ListAppPurRequestRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        PrTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppPurRequestRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppPurRequest';
        export const lookupKey = 'Purchase.ListAppPurRequest';

        export function getLookup(): Q.Lookup<ListAppPurRequestRow> {
            return Q.getLookup<ListAppPurRequestRow>('Purchase.ListAppPurRequest');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            PrTypeFg = "PrTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
